/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-underscore-dangle */
import { useEffect, useRef, useState } from 'react';
import qs from 'qs';
import {
  add, format, getDate, getMonth,
} from 'date-fns';
import { useDispatch } from 'react-redux';
import {
  Box,
  Button,
  Container,
  Grid,
  Paper,
  styled,
  TableBody,
  TableContainer,
  TableHead,
} from '@mui/material';
import { useRouter } from 'next/router';
import { isEmpty, uniqueId } from 'lodash';

import {
  ComponentBlock,
  GoyoloSeoTemplateData,
  Heading,
  ILangObj,
} from '@/slices/goyoloSeo/sliceType';

import { IObjectState } from '@/containers/CompanyPageVcms';
import { useAppDispatch, useAppSelector } from '@/utils/hook';
import {
  addFlight,
  removeFlight,
  removeReturnFlight,
} from '@/slices/selectedFlight/slices/selectedFlightSlice';
import {
  addAllPoints,
  addFallbackPoints,
  addHomePoints,
  adjustAllPassengers,
  adjustSeatClass,
  clearHomePoints,
  clearPoints,
} from '@/slices/area/slices/searchFlightFormSlice';
import { getParamsFlightMapping, getParamsFlightMappingVcms } from '@/utils/paramsMapping';
import { checkDate, setCalendarType, setSelectedDate } from '@/slices/calendar/calendarSlice';
import { resetSelectedContact } from '@/slices/passenger/slices/passengerSlice';
import { useLazyGetFlightByIdQuery } from '@/slices/flightData/apis/flightDataApi';
import { generateDays } from '@/components/RoutePageVcms/SectionManager/utils';
import { LIST_AIRLINES_SLUG, SEO_PAGE_TYPE, tetDays } from '@/utils/constants';
import ListDetailVcms from '@/components/Vcms/ListDetailVcms';
import { get } from 'lodash';
import { StyledTableRow } from '@/components/StyledTableRow';
import { convertStrToComp } from '@/utils/convertStrToComp';
import dynamic from 'next/dynamic';
import { getHostnameFromEnv } from '@/utils/getHostName';
import OtherCompanyFlightUrls from '@/components/Vcms/OtherCompanyFlightUrls';
import ContentTableComponent from '@/components/Vcms/ContentTableComponent';
import { getInnerHtmlTag } from '@/utils/getInnerHtmlTag';
import { setTableContent } from '@/slices/goyoloSeo/goyoloSeoSlice';
import ContentTableComponentDesktop from '@/components/Vcms/ContentTableComponentDesktop';
import { style } from '@/styles/globals';
import { useBoolean } from '@/utils/hooks';
import { getMappingDatePriceData, getMappingDatePriceDataCalendar } from '@/components/RouteCompanyCityToCity/SectionManager';

import HeaderBarVex from '../../components/Vcms/HeaderBar';
import LandingPageVcms from '../../components/Vcms/Desktop/LandingPage';
import HeaderTabsVcms from '../../components/Vcms/HeaderTabsVcms';
import HeaderBarVexDesktop from '../../components/Vcms/HeaderBar/desktop';
import PartnersVex from '../../components/Vcms/GoyoloPartner';
import PartnersVexDesktop from '../../components/Vcms/GoyoloPartner/desktop';
import UniqueSellingPointsVex from '../../components/Vcms/SectionWhyBookUs';
import UniqueSellingPointsVexDesktop from '../../components/Vcms/SectionWhyBookUs/desktop';
import BannerDiscount from '../../components/Vcms/BannerDiscountVcms';
import FareInDayNewYearVcms from '../../components/Vcms/FareInDayNewYearVcms';
import SearchMiniInputVcms from '../../components/Vcms/SearchMiniInputVcms';
import CalendarFareInMonthVcms from '@/components/Vcms/CalendarFareInMonthVcms';
import CalendarFareInMonthVcmsDesktop from '@/components/Vcms/CalendarFareInMonthVcms/desktop';
import CalendarFareNewYearVcms from '@/components/Vcms/CalendarFareNewYearVcms';
import FareByAirlineInMonthVcms from '@/components/Vcms/FareByAirlineInMonthVcms';
import FareInMonthVcms from '@/components/Vcms/FareInMonthVcms';
import FareInWeekVcms from '@/components/Vcms/FareInWeekVcms';
import TableFareVcms from '@/components/Vcms/TableFareVcms';
import AirportToCityTable from '@/components/Vcms/AirportToCityTable';
import HorizontalMinFareBarVcms from '@/components/Vcms/HorizontalMinFareBarVcms';
import PathBreadcrumbsVcms from '@/components/Vcms/PathBreadcrumbsVcms';
import FlexTableRow from '@/components/FlexTableRow';
import WideTableCell from '@/components/WideTableCell';
import PopularRoutesAirlineFromToCityVcms from '@/components/Vcms/PopularRoutesAirlineFromToCityVcms';
import LunarNewYearAirfareByPolularRoute from '@/components/Vcms/LunarNewYearAirfareByPolularRoute';
import LunarNewYearAirfareByAirline from '@/components/Vcms/LunarNewYearAirfareByAirline';
import FAQListVcms from '@/components/Vcms/FAQListVcms';
import FooterBar from '@/components/Vcms/FooterBar';
import FooterBarDesktop from '@/components/Vcms/FooterBar/Desktop';
import NewYearAirfareByPolularRoute from '@/components/Vcms/NewYearAirfareByPolularRoute';
import { removeVietnameseTones } from '@/utils/stringConvert';
import { templateStr } from '@/utils/templateStr';
import { resetFilter } from '@/slices/filterFlight/filterFlightSlice';
import { resetSortingFlight } from '@/slices/sortingFlight/sortingFlightSlice';
import React from 'react';
import CompanyToRouteVcms from '@/components/Vcms/CompanyToRouteVcms';
import CityMapping from '@/mappings/airport_vn.json';

const VcmsContainer = styled(Box)<CustomStyleProps>`
  word-wrap: break-word;  
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  font-size: 14px;
  h1 {
    font-size: 40px;
  }

  h2 {
    font-size: 24px;
  }

  h3 {
    font-size: 18px;
  }

  thead tr {
    background-color: #f2f2f2;
  }
  thead tr th {
    --border: 1px solid rgb(193, 199, 208);
    padding: 7px 10px;
    vertical-align: top;
  }
  td,
  th {
    padding: 4px 8px;
  }
  tbody tr td {
    --border: 1px solid rgb(193, 199, 208);
    padding: 7px 10px;
    vertical-align: top;
    td {
      border: 0;
    }
  }

  figure {
    overflow: auto;
  }

  ${(props: any) => props.customStyle || ''}
`;
const StyledTitle = styled('p')`
  color: #2574e5;
  font-size: 2rem;
  font-weight: bold;
  text-align: center;
  padding: 0;
  margin: 0;
  margin-bottom: 1em;
`;
const StyledBody = styled('div')`
  display: flex;
  justify-content: center;
`;
const StyledButton = styled(Button)`
:hover {
  background: ${style.primary.navy};
  color: ${style.color.white4};
  border: 1px solid ${style.neutral.border};
}
border: 1px solid ${style.neutral.border};
`;

function CompanyPageVcmsBody(props: {
  isTrain?: boolean;
  isDesktop: boolean;
  countTetResult?: any;
  countSeoTetResult?: any;
  branchPage?: IObjectState;
  templateDataObj?: any;
  tetData: any,
  countResult: any;
  startPoint: any,
  toPoint: any,
  company: any,
  airport: any,
  imagePromotion?: any
}) {
  const {
    isDesktop, templateDataObj, startPoint: startPointSeo, toPoint: toPointSeo, company, airport: airportSeo, imagePromotion, isTrain,
  } = props;
  const [isFirstTime, setIsFirstTime] = useState(true);

  const dispatch = useDispatch();
  const router = useRouter();
  const today = new Date();
  const {
    calculatedParams, templateParamObj, templateData, lang,
  } = templateDataObj || {};
  const [getFlightDepartById, { data: flightById, isError: isGetFlightError }] = useLazyGetFlightByIdQuery();
  const { selectedDate } = useAppSelector((state: any) => state.calendar);
  const searchFlightForm = useAppSelector((state: any) => state.searchFlightForm);
  const [open, setOpen] = useBoolean(false);
  const [clickDate, setClickDate] = useState(null);
  const requestObjState = useRef({});

  const statePassenger = isFirstTime ? {
    adt: 1,
    chd: 0,
    inf: 0,
  } : searchFlightForm?.passenger;
  const stateSeatClass = isFirstTime ? 'PT' : searchFlightForm.seatClass;
  const startPoint = isFirstTime ? startPointSeo : searchFlightForm.startPointHome;
  const toPoint = isFirstTime ? toPointSeo : searchFlightForm.toPointHome;

  useEffect(() => {
    requestObjState.current = {
      startPoint,
      toPoint,
      selectedDate,
      statePassenger,
      stateSeatClass,
    };
  }, [searchFlightForm, selectedDate]);

  const days = generateDays({
    date: today.toISOString(),
    minDate: today.toISOString(),
    maxDate: add(today, { months: 1 }).toISOString(),
  });

  const findDayNewYear = tetDays.find((day) => (day.monthVN === 1 && day.dayVN === 1));

  const { query: { slug } } = router;

  const switchUpdateSecondTime = () => {
    if (isFirstTime) {
      setIsFirstTime(false);
      dispatch(addFallbackPoints());
      dispatch(resetFilter());
      dispatch(resetSortingFlight());
      dispatch(setSelectedDate({
        dateObj: JSON.stringify({
          depart: new Date(),
          return: null,
        }),
      }));
      if (slug) {
        if ((!company && isEmpty(startPointSeo) && !isEmpty(toPointSeo))
      || (company && !isEmpty(toPointSeo) && isEmpty(startPointSeo))) {
          dispatch(clearPoints({ type: 'from' }));
          dispatch(clearHomePoints({ type: 'from' }));
        } else if (company && isEmpty(toPointSeo)) {
          dispatch(clearPoints({ type: 'all' }));
        } else if (airportSeo) {
          dispatch(clearPoints({ type: 'all' }));
        }
      }
      if (!isEmpty(startPointSeo)) {
        dispatch(
          addHomePoints({
            type: 'from',
            data: startPointSeo,
          }),
        );
      }
      if (!isEmpty(toPointSeo)) {
        dispatch(
          addHomePoints({
            type: 'to',
            data: toPointSeo,
          }),
        );
      }
    }
  };

  const onSearchFlight = (newSelectedDate?: any) => {
    const currObjState = requestObjState.current as any;
    const tmpStartPoint = currObjState.startPoint;
    const tmpToPoint = currObjState.toPoint;
    const tmpSelectedDate = newSelectedDate || currObjState.selectedDate;

    const tmpPassenger = currObjState.statePassenger;
    const tmpSeatClass = currObjState.stateSeatClass || 'PT';
    console.log('onSearchFlight', {
      tmpStartPoint,
      tmpToPoint,
      tmpSelectedDate,
      tmpPassenger,
      tmpSeatClass,
    });
    if (
      !tmpStartPoint
      || !tmpToPoint
      || !tmpSelectedDate
      || !tmpPassenger
      || !tmpSeatClass
    ) {
      return;
    }
    dispatch(removeFlight());
    dispatch(removeReturnFlight());

    dispatch(
      addAllPoints([
        {
          data: tmpStartPoint,
          type: 'from',
        },
        {
          data: tmpToPoint,
          type: 'to',
        },
      ]),
    );
    dispatch(setSelectedDate({ dateObj: JSON.stringify(tmpSelectedDate) }));
    dispatch(adjustAllPassengers(tmpPassenger));
    dispatch(adjustSeatClass({ seatClass: tmpSeatClass }));

    const path = getParamsFlightMappingVcms({
      tmpPassenger,
      tmpSeatClass,
      tmpSelectedDate,
      tmpToPoint,
      tmpStartPoint,
      useRootPath: true,
      lang,
    });
    window.location.href = path;
  };

  const handleSelectTrip = (item: any) => {
    const date = {
      depart: item?.date || item?.pickup_date || '',
      return: '',
    };
    onSearchFlight(date);
  };

  const handleSelectFromDate = (dateStr: string) => {
    dispatch(setSelectedDate({ dateObj: JSON.stringify({ depart: dateStr }) }));
  };

  const getPopularRoutesAirlineFromToCityVcmsTitle = ({
    airlineName, airport, toName, showToOnly, fromName,
  }: any) => {
    toName = lang?.lang === 'en' ? removeVietnameseTones(toName) : toName;
    const fromTitle = airlineName ? templateStr(lang?.lang === 'en' ? lang?.PopularRotes?.airlinePopularRoutes : 'Chặng bay phổ biến {{airlineName}}', { airlineName }) : templateStr(lang?.lang === 'en' ? lang?.PopularRotes?.popularRoutesFrom : 'Các chặng bay phổ biến từ {{location}}', { location: fromName });
    const toTitle = airlineName ? templateStr(lang?.lang === 'en' ? lang?.PopularRotes?.airlinePopularRoutes : 'Chặng bay phổ biến {{airlineName}}', { airlineName }) : templateStr(lang?.lang === 'en' ? lang?.PopularRotes?.popularRoutesTo : 'Chặng bay phổ biến đến {{location}}', { location: toName });
    const toOnlyTitle = airlineName ? templateStr(lang?.lang === 'en' ? lang?.PopularRotes?.airlinePopularDestination : 'Điểm đến phổ biến {{airlineName}}', { airlineName }) : templateStr(lang?.lang === 'en' ? lang?.PopularRotes?.popularRoutesTo : 'Chặng bay phổ biến đến {{location}}', { location: toName });
    const titleAirport = airport ? `Chặng bay phổ biến đến ${airport.name}` : '';
    const titleComp = airport ? titleAirport : fromName ? fromTitle : toName ? (showToOnly ? toOnlyTitle : toTitle) : '';
    return titleComp;
  };
  // elements.faq-list
  const getTitle = (instanceName: string) => {
    switch (instanceName) {
      case 'elements.faq-list':
        return `${lang?.FAQ?.title || 'Các câu hỏi thường gặp về tuyến đường'} ${calculatedParams?.routeName}`;
      case 'OtherCompanyFlightUrls': {
        const showToOnly = calculatedParams.pageType === SEO_PAGE_TYPE.AIRLINE_TO_PAGE;
        const titleComp = (lang?.lang === 'en' ? templateStr(lang?.OtherCompanyFlightUrls?.title, {
          fromLocation: removeVietnameseTones(!showToOnly ? calculatedParams?.from_name : ''),
          toLocation: removeVietnameseTones(calculatedParams?.to_name),
        }) : `Vé máy bay ${!showToOnly ? calculatedParams?.from_name : ''} đi ${calculatedParams?.to_name} của các hãng hàng không khác`);
        return titleComp;
      }
      case 'OtherFlightCompanyToCityUrls': {
        const titleComp = (lang?.OtherFlightCompanyToCityUrls?.title ? templateStr(lang?.OtherFlightCompanyToCityUrls?.title, {
          company: calculatedParams?.airlineName,
        }) : `Điểm đến phổ biến của ${calculatedParams?.airlineName}`);
        return titleComp;
      }
      case 'PopularRoutes': {
        if (calculatedParams.pageType === SEO_PAGE_TYPE.FROM_TO_PAGE) {
          const title1 = getPopularRoutesAirlineFromToCityVcmsTitle({
            // toName: calculatedParams?.to_name,
            showToOnly: true,
            fromName: calculatedParams?.from_name,
          });
          const title2 = getPopularRoutesAirlineFromToCityVcmsTitle({
            toName: calculatedParams?.to_name,
          });
          const title3 = `Các hãng khai thác đường bay ${calculatedParams?.from_name} - ${calculatedParams?.to_name}`;

          return `${title1}////${title2}////${title3}`;
        }
        if (calculatedParams.pageType === SEO_PAGE_TYPE.TO_PAGE) {
          const title = getPopularRoutesAirlineFromToCityVcmsTitle({
            toName: calculatedParams?.to_name,
          });
          return title;
        }
        if (calculatedParams.pageType === SEO_PAGE_TYPE.AIRPORT_PAGE) {
          const title = getPopularRoutesAirlineFromToCityVcmsTitle({
            toName: calculatedParams?.from_name,
          });
          return title;
        }
        if (calculatedParams.pageType === SEO_PAGE_TYPE.AIRLINE_TO_PAGE) {
          const title = getPopularRoutesAirlineFromToCityVcmsTitle({
            toName: calculatedParams?.from_name,
          });
          return title;
        }
        if (calculatedParams.pageType === SEO_PAGE_TYPE.AIRLINE_FROM_TO_PAGE) {
          // const title1 = getPopularRoutesAirlineFromToCityVcmsTitle({
          //   company: calculatedParams?.company,
          //   toName: calculatedParams?.to_name,
          //   showToOnly: true,
          // });
          // const title2 = getPopularRoutesAirlineFromToCityVcmsTitle({
          //   company: calculatedParams?.company,
          //   toName: calculatedParams?.to_name,
          // });
          const title1 = `${lang?.lang === 'en' ? 'Most Popular routes of ' : 'Chặng bay phổ biến của '}${calculatedParams.airlineName}`;
          const title2 = `${lang?.lang === 'en' ? 'Most popular routes to ' : 'Chặng bay phổ biến đến '}${calculatedParams?.to_name}`;
          const title3 = `Tham khảo các hãng khác cũng khai thác tuyến ${calculatedParams?.from_name} - ${calculatedParams?.to_name}`;
          return `${title1}////${title2}////${title3}`;
        }
        return '';
        // if (calculatedParams.pageType === SEO_PAGE_TYPE.AIRLINE_FROM_TO_PAGE) {
        //   const title1 = 'showToOnly';
        //   const title2 = '';
        // }
      }
      default:
        return '';
    }
  };

  const blocks = JSON.parse(JSON.stringify(templateData?.attributes?.blocks || []));
  const tableContent1 = [] as any[];
  let tableContentContainerIdx = false;
  const listBlock1: ComponentBlock[] = [];
  const listBlock2: ComponentBlock[] = [];
  let tableContentBlock = null;
  blocks.forEach((block: any, parentIdx: number) => {
    if (block.name === 'TableOfContentContainer') {
      tableContentContainerIdx = true;
      tableContentBlock = block;
    }
    (block.children || []).forEach((b: any, idx: number) => {
      let title;
      if (b.content) {
        title = getInnerHtmlTag(b.content);
        if (title) {
          tableContent1.push({
            title,
            comp: b.__component,
            id: b.id,
            idx,
            parentIdx,
          });
        }
        b.headingContent = {
          title,
          comp: b.__component,
          id: b.id,
          idx,
          parentIdx,
        };
      } else {
        title = getTitle(b?.__component) || getTitle(b?.name) || getTitle(b?.instance);
        const titleArr = title.split('////');
        const title1 = titleArr?.[0];
        if (title) {
          tableContent1.push({
            title: title1,
            comp: b.__component,
            id: b.id,
            idx,
            parentIdx,
          });
          if (titleArr?.length === 2) {
            tableContent1.push({
              title: titleArr?.[1],
              comp: b.__component,
              id: b.id + 1,
              idx,
              parentIdx,
            });
          }
          b.headingContent = {
            title,
            comp: b.__component,
            id: b.id,
            idx,
            parentIdx,
          };
        } else {
          b.headingContent = {
            idx,
            parentIdx,
          };
        }
      }
    });
    if (!tableContentContainerIdx) {
      listBlock1.push(block);
    } else {
      listBlock2.push(block);
    }
  });
  const daysInNewYears = getMappingDatePriceData(props.countSeoTetResult);

  const BlockComps1 = listBlock1.map((block: ComponentBlock) => recurseBuildBlock(block, {
    ...props,
    ...calculatedParams,
    ...templateParamObj,
    airlines: LIST_AIRLINES_SLUG,
    selectedDate,
    onSearchFlight,
    handleSelectTrip,
    daysInNewYears,
    findDayNewYear,
    handleSelectFromDate,
    isFetching: false,
    errorStatistics: null,
    dayTetPriceObjs: getMappingDatePriceDataCalendar(props.countTetResult),
    startPoint,
    toPoint,
    setOpen,
    lang,
    isFirstTime,
    switchUpdateSecondTime,
    statePassenger,
    stateSeatClass,
    imagePromotion,
  }));
  const BlockComps2 = listBlock2.map((block: ComponentBlock) => recurseBuildBlock(block, {
    imagePromotion,
    ...props,
    ...calculatedParams,
    ...templateParamObj,
    airlines: LIST_AIRLINES_SLUG,
    selectedDate,
    onSearchFlight,
    handleSelectTrip,
    daysInNewYears,
    findDayNewYear,
    handleSelectFromDate,
    isFetching: false,
    errorStatistics: null,
    startPoint,
    toPoint,
    setOpen,
    lang,
    isFirstTime,
    switchUpdateSecondTime,
    statePassenger,
    stateSeatClass,
  }));
  if (!isDesktop) {
    return (
      <VcmsContainer customStyle={{
        ...templateData?.attributes?.ui?.cssStyle,
      }}
      >
        {BlockComps1}
        <LayoutContainer block={tableContentBlock}>
          <TableOfContent
            lang={lang}
            tableContent={tableContent1}
          />
        </LayoutContainer>
        {BlockComps2}
        <FooterBar
          ismobile
          lang={lang}
        />
      </VcmsContainer>
    );
  }
  return (
    <VcmsContainer customStyle={{
      ...templateData?.attributes?.ui?.cssStyle,
    }}
    >
      {BlockComps1}
      <LayoutContainer>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={9}
          >
            {BlockComps2}
          </Grid>
          <Grid
            item
            xs={3}
          >
            <ContentTableComponentDesktop
              lang={lang}
              tableContent={tableContent1}
            />
          </Grid>
        </Grid>
      </LayoutContainer>
      <FooterBarDesktop lang={lang} />
    </VcmsContainer>
  );
}

const excludedWrapperCompArr = [
  'sections.navbar',
  'layout.block',
  'layout.container',
];
const recurseBuildBlock = (block: ComponentBlock, props: any = {}) => {
  let Comp;
  if (block.parent?.toLowerCase()?.includes('tet') && block.instance === 'FareCalendar') {
    Comp = vcmsComponentMapping.NewYearFareCalendar;
  } else {
    Comp = vcmsComponentMapping[block.instance || block.__component || ''];
  }
  if (Comp) {
    const ChildComps = (block.children || []).map((b) => recurseBuildBlock(b, props));
    if (
      excludedWrapperCompArr.includes(block.instance || block.__component || '')
    ) {
      return (
        <Comp
          key={`${block.__component}_${block.id}`}
          block={block}
          {...props}
        >
          {ChildComps}
        </Comp>
      );
    }
    return (
      <BaseVcmsComponent>
        <div
          style={{ color: '#000' }}
          id={`content_${block.headingContent?.idx}_${block.headingContent?.parentIdx}`}
        >

          <Comp
            key={`${block.__component}_${block.id}`}
            block={block}
            {...props}
          >
            {ChildComps}
          </Comp>
        </div>
      </BaseVcmsComponent>
    );
  }
  return null;
};

// __component: Base component on which other component are built on
// instance: Sub-component inherited the base component and add style on it
export type CustomStyleProps = {
  block?: any;
  customStyle?: string;
};

const StyledBox = styled(Box)<CustomStyleProps>`
  // border: 1px solid grey;
  width: 100%;
  padding: 0.5em 0;
  margin: 0;
  ${(props: any) => props.customStyle || ''}
  ${(props: any) => props.block?.ui?.cssStyle || ''}
`;

const StyledBoxMobile = styled(Box)<CustomStyleProps>`
  // border: 1px solid grey;
  // width: 100%;
  margin: 0;
  width: 100%;
  background: #2474E5;
  background-size: cover;
  background-position: center -200px;
  background-repeat: no-repeat;
`;

const StyledContainer = styled(Container)<CustomStyleProps>`
  ${(props: any) => (props.block?.name === 'FAQ' ? 'background: white;' : '')}
  ${(props: any) => props.customStyle || ''}
  ${(props: any) => props.block?.name === 'topHeroContainer'}
  ${(props: any) => props.block?.ui?.cssStyle || ''}
`;

const BaseVcmsComponent = ({ children }: any) => (
  <StyledBox>{children || 'EMPTY'}</StyledBox>
);
const SectionNavBar = ({ children }: any) => <>{children}</>;
const LayoutBlock = ({ block, children, isDesktop }: any) => {
  if ((block?.name === 'topHeroSection' || block?.name === 'HeroSection') && !isDesktop) {
    return (
      <StyledBoxMobile
        block={block}
        className="mobile"
      >
        {children}
      </StyledBoxMobile>
    );
  }
  return (
    <StyledBox block={block}>{children}</StyledBox>
  );
};
const LayoutContainer = ({ block, children }: any) => (
  <StyledContainer
    block={block}
  >
    {children}
  </StyledContainer>
);
const TableOfContent = (props: any) => {
  const { isDesktop, lang, tableContent } = props;
  return (
    <ContentTableComponent
      tableContent={tableContent}
      isDesktop={isDesktop}
      lang={lang}
    />
  );
};

const ElementParagraph = ({ block }: any) => {
  const customStyle = `
    figure {
      margin-right: auto;
      margin-left: auto;
    }
    figure.table {
      overflow: auto;
      box-shadow: 0px 2px 10px rgb(7 65 57 / 15%);
    }
    table { 
      border-collapse: collapse;
      border-radius: 8px;
    }
    thead tr {
      background-color: #F2F2F2;
    }
    td, th {
      padding: 4px 8px;
    }
    img {
      width: 100%
    }
    h1 {
      margin: 0;
      font-weight: 700;
      font-size: 32px;
      line-height: 40px;
    }
    .mobile.h1 {
      margin: 0 1em;
    }
    li {
      margin-bottom: 16px;
    }
    li > a {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      text-decoration-line: underline;
      color: #2474E5;
    }
  `;

  return (
    <StyledBox
      block={block}
      customStyle={customStyle}
      // dangerouslySetInnerHTML={{ __html: block.content }}
    >
      {convertStrToComp(block.content)}
    </StyledBox>
  );
};

const ElementNotice = ({ children }: any) => <>{children}</>;
const ElementFlexiComponent = ({ children }: any) => <>{children}</>;
const ElementFlexiCard = ({ children }: any) => <>{children}</>;
const SearchBox = ({
  isDesktop,
  branchPage,
  onSearchFlight,
  lang,
  startPoint,
  toPoint,
  isFirstTime,
  switchUpdateSecondTime,
  statePassenger,
  isTrain,
  stateSeatClass,
}: {
  isDesktop: boolean;
  branchPage?: IObjectState;
  onSearchFlight: any;
  lang: ILangObj;
  startPoint: any,
  toPoint: any,
  isFirstTime: boolean,
  switchUpdateSecondTime: any,
  statePassenger: any,
  stateSeatClass: any,
  isTrain?: boolean,
}) => {
  const formatDate = ` ngày ${getDate(new Date())} tháng ${
    getMonth(new Date()) + 1
  }`;
  const dispatch = useAppDispatch();

  if (isTrain) {
    if (isDesktop) {
      return (
        <Container sx={{
          height: {
            xs: '400px',
            lg: '220px',
          },
        }}
        />
      );
    }
    return (
      <Container sx={{
        height: {
          xs: '100px',
        },
      }}
      />
    );
  }

  return isDesktop ? (
    <LandingPageVcms
      isTrain={isTrain}
      isFirstTime={isFirstTime}
      title={`Vé máy bay ${branchPage?.name} giá rẻ nhất${formatDate}`}
      // filterAirline={[branchPage?.type]}
      onSearchClick={onSearchFlight}
      lang={lang}
      startPoint={startPoint}
      toPoint={toPoint}
      switchUpdateSecondTime={switchUpdateSecondTime}
      statePassenger={statePassenger}
      stateSeatClass={stateSeatClass}
    />
  ) : (
    <HeaderTabsVcms
      isTrain={isTrain}
      isFirstTime={isFirstTime}
      // filterAirline={[branchPage?.type]}
      onSearchClick={onSearchFlight}
      onClickTab={(newTab: string) => {
        dispatch(setCalendarType({ calendarType: newTab as any }));
        dispatch(checkDate());
      }}
      lang={lang}
      startPoint={startPoint}
      toPoint={toPoint}
      statePassenger={statePassenger}
      stateSeatClass={stateSeatClass}
      switchUpdateSecondTime={switchUpdateSecondTime}
    />
  );
};
const Banner = ({ children }: any) => (
  <ElementFlexiCard>{children}</ElementFlexiCard>
);

const ElementFAQList = (props: any) => {
  const {
    isDesktop, routeName, block, lang,
  } = props;
  return (
    <FAQListVcms
      routeName={routeName}
      block={block}
      isDesktop={isDesktop}
      idComponent="faq"
      metaJson={block.metaFaq || ''}
      params={props}
      lang={lang}
    />
  );
};

const AirlineFareInMonthTable = ({
  selectedDate,
  handleSelectTrip,
  flightDataAll,
  isDesktop,
  airlineCode,
  hidePrice,
  countResult,
  lang,
}: any) => (
  <TableFareVcms
    lang={lang}
    countResult={countResult}
    airline={airlineCode}
    isDesktop={isDesktop}
    selectedDate={selectedDate}
    flightData={flightDataAll}
    onSelectTrip={handleSelectTrip}
    hidePrice={hidePrice}
  />
);

const AirportToCity = ({
  handleSelectTrip,
  isDesktop,
  cheapestTripAirport,
  lang,
}: any) => (
  <AirportToCityTable
    cheapestTripAirport={cheapestTripAirport}
    isDesktop={isDesktop}
    onSelectTrip={handleSelectTrip}
    lang={lang}
  />
);

const NewYearFareCalendar = ({
  selectedDate,
  onSearchFlight,
  dayPriceObj,
  dayTetPriceObjs,
  findDayNewYear,
  lang,
}: any) => (
  <CalendarFareNewYearVcms
    dayPriceObj={dayPriceObj}
    selectedDate={selectedDate}
    onSearchFlight={onSearchFlight}
    dayTetPriceObjs={dayTetPriceObjs}
    findDayNewYear={findDayNewYear}
    lang={lang}

  />
);

const FareInMonthTable = ({
  days,
  onSearchFlight,
  routeName,
  isDesktop,
  lang,
}: any) => (
  <FareInMonthVcms
    lang={lang}
    isDesktop={isDesktop}
    days={days}
    onSearchFlight={onSearchFlight}
    numberDayInMonth={3}
    routeName={routeName}
  />
);

const LowestPriceTodayTable = ({
  days,
  onSearchFlight,
  routeName,
  isDesktop,
}: any) => (
  <FareInMonthVcms
    isDesktop={isDesktop}
    days={days}
    onSearchFlight={onSearchFlight}
    numberDayInMonth={3}
    routeName={routeName}
  />
);
const FareTableWithBar = ({
  days,
  selectedDate,
  handleSelectTrip,
  flightData,
  handleSelectFromDate,
  isFetching,
  errorStatistics,
  isDesktop,
  lang,
}: any) => (
  <>
    <HorizontalMinFareBarVcms
      isDesktop={isDesktop}
      days={days}
      selectedDate={selectedDate}
      onSelectDate={handleSelectFromDate}
      isFetching={isFetching}
      errorStatistics={errorStatistics}
    />
    <TableFareVcms
      lang={lang}
      isDesktop={isDesktop}
      selectedDate={selectedDate}
      flightData={flightData}
      onSelectTrip={handleSelectTrip}
    />
  </>
);

const FareCalendar = ({
  selectedDate,
  onSearchFlight,
  dayPriceObjStatictis,
  isDesktop,
  lang,
  countResult,
}: any) => (!isDesktop ? (
  <CalendarFareInMonthVcms
    countResult={countResult}
    dayPriceObj={dayPriceObjStatictis}
    selectedDate={selectedDate}
    onSearchFlight={onSearchFlight}
    lang={lang}
  />
) : (
  <CalendarFareInMonthVcmsDesktop
    countResult={countResult}
    type="depart"
    onSearchFlight={onSearchFlight}
    lang={lang}
  />
));

const AirlineFareTable = ({
  days, handleSelectTrip, isDesktop, lang,
}: any) => (
  <FareByAirlineInMonthVcms
    days={days}
    isDesktop={isDesktop}
    onSelectTrip={handleSelectTrip}
    // numberDayInMonth={3}
    lang={lang}
  />
);

const HorizontalFareBar = ({
  days,
  selectedDate,
  handleSelectFromDate,
  isFetching,
  errorStatistics,
  isDesktop,
}: any) => (
  <HorizontalMinFareBarVcms
    isDesktop={isDesktop}
    days={days}
    selectedDate={selectedDate}
    onSelectDate={handleSelectFromDate}
    isFetching={isFetching}
    errorStatistics={errorStatistics}
  />
);

const FareInWeekTable = ({
  days, onSearchFlight, isDesktop, lang,
}: any) => (
  <FareInWeekVcms
    isDesktop={isDesktop}
    days={days}
    onSearchFlight={onSearchFlight}
    lang={lang}
  />
);

const FareTable = ({
  selectedDate,
  handleSelectTrip,
  flightData,
  isDesktop,
  lang,
}: any) => (
  <TableFareVcms
    isDesktop={isDesktop}
    selectedDate={selectedDate}
    flightData={flightData}
    onSelectTrip={handleSelectTrip}
    lang={lang}
  />
);

const MiniSearchBox = ({
  isDesktop, lang, startPoint, toPoint, switchUpdateSecondTime, isFirstTime,
}: any) => (
  <SearchMiniInputVcms
    lang={lang}
    startPoint={startPoint}
    toPoint={toPoint}
    switchUpdateSecondTime={switchUpdateSecondTime}
    isFirstTime={isFirstTime}
  />
);

const NewYearFareTable = ({
  isDesktop,
  daysInNewYears,
  company,
  airlines,
  handleSelectTrip,
  lang,
}: any) => (
  <FareInDayNewYearVcms
    company={company}
    airlines={airlines}
    isDesktop={isDesktop}
    days={daysInNewYears}
    onSelectTrip={handleSelectTrip}
    lang={lang}
  />
);

const Partners = ({ isDesktop }: any) => (isDesktop ? <PartnersVexDesktop /> : <PartnersVex />);

const UniqueSellingPoints = ({
  isDesktop,
  lang,
  startPoint,
  toPoint,
  company,
}: any) => {
  // eslint-disable-next-line eqeqeq
  const startPointEn = CityMapping.airports.find((e) => e.VxrAreaParentId == startPoint?.id)?.CityName_En || '';
  // eslint-disable-next-line eqeqeq
  const toPointEn = CityMapping.airports.find((e) => e.VxrAreaParentId == toPoint?.id)?.CityName_En || '';
  const isEN = lang.lang === 'en';

  return isDesktop ? (
    <>
      <UniqueSellingPointsVexDesktop lang={lang} />
      {isEN && !company && (
        <>
          <CompanyToRouteVcms
            title={`Airlines operating the ${startPointEn} - ${toPointEn} route:`}
            startPoint={startPoint}
            toPoint={toPoint}
            isEN={lang.lang === 'en'}
          />
          <CompanyToRouteVcms
            startPoint={toPoint}
            toPoint={startPoint}
            isEN={lang.lang === 'en'}
          />
        </>
      )}
    </>
  ) : (
    <>
      <UniqueSellingPointsVex lang={lang} />
      {isEN && !company && (
        <>
          <CompanyToRouteVcms
            title={`Airlines operating the ${startPointEn} - ${toPointEn} route:`}
            startPoint={startPoint}
            toPoint={toPoint}
            isEN={lang.lang === 'en'}
          />
          <CompanyToRouteVcms
            startPoint={toPoint}
            toPoint={startPoint}
            isEN={lang.lang === 'en'}
          />
        </>
      )}
    </>
  );
};

const HeaderBar = ({
  lang, isDesktop, airport, pageType,
}: any) => (isDesktop ? (
  <HeaderBarVexDesktop
    lang={lang}
    airport={airport}
    pageType={pageType}
  />
) : (
  <HeaderBarVex
    lang={lang}
    airport={airport}
    pageType={pageType}
  />
));

const GeneralInfo = ({
  dataObj, airlineNameList, isDesktop, company, lang,
}: any) => (
  <ListDetailVcms
    dataObj={dataObj}
    airlines={airlineNameList}
    isDesktop={isDesktop}
    airlineSlug={company}
    lang={lang}
  />
);

const Breadcrumb = ({ block, lang }: any) => (
  <PathBreadcrumbsVcms
    linkArr={get(block, 'links')}
    lang={lang}
  />
);

const PopularRoutesAirlineFromToCity = ({
  startPoint, toPoint, isDesktop, company, showToOnly, airport, block, lang, title,
}: any) => (
  <PopularRoutesAirlineFromToCityVcms
    block={block}
    startPoint={startPoint}
    toPoint={toPoint}
    airlineSlug={company}
    showToOnly={showToOnly}
    isDesktop={isDesktop}
    airport={airport}
    lang={lang}
    title={title}
  />
);

const CompanyToRoute = (props: any) => (
  // <CompanyToRouteVcms
  //   startPoint={startPoint}
  //   toPoint={toPoint}
  //   airline={company}
  // />
  <PopularRoutesAirlineFromToCity
    {...props}
    startPoint={null}
    showToOnly
  />
);

const PopularRoutesFromCity = ({ startPoint, company, lang }: any) => (
  <PopularRoutesAirlineFromToCity
    startPoint={startPoint}
    company={company}
    lang={lang}
  />
);

const PopularRoutesToCity = ({ toPoint, company, lang }: any) => (
  <PopularRoutesAirlineFromToCity
    toPoint={toPoint}
    company={company}
    lang={lang}
  />
);

const PopularRoutesFromToCity = ({ startPoint, toPoint, lang }: any) => (
  <PopularRoutesAirlineFromToCity
    startPoint={startPoint}
    toPoint={toPoint}
    lang={lang}
  />
);
const AirlineIntroductions = ({ introductionCityToCityArr }: any) => (
  <>
    {(introductionCityToCityArr || []).map((introduction: string) => (
      <div
        key={uniqueId()}
        // dangerouslySetInnerHTML={{ __html: introduction }}
      >
        {convertStrToComp(introduction)}
      </div>
    ))}
  </>
);
const CompanyBaggage = ({ company }: any) => (
  <>
    <StyledTitle>
      Bảng giá mua thêm hành lý ký gửi
      {' '}
      {company}
    </StyledTitle>
    <StyledBody>
      <TableContainer
        component={Paper}
        sx={{
          boxShadow: 'none',
        }}
      >
        <TableHead>
          <FlexTableRow
            sx={{
              background: 'white',
              border: 0,
            }}
          >
            <WideTableCell
              align="center"
              sx={{ whiteSpace: 'nowrap' }}
            >
              Trọng lượng
            </WideTableCell>
            <WideTableCell
              sx={{ whiteSpace: 'nowrap' }}
              align="center"
            >
              Giá tiền
            </WideTableCell>
          </FlexTableRow>
        </TableHead>
        <TableBody>
          <StyledTableRow>
            <WideTableCell align="center">10kg (22lb)</WideTableCell>
            <WideTableCell align="center">150.000 - 170.000</WideTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <WideTableCell align="center">23kg (50lb)</WideTableCell>
            <WideTableCell align="center">250.000 - 280.000</WideTableCell>
          </StyledTableRow>
        </TableBody>
      </TableContainer>
    </StyledBody>
  </>
);

const PopularRoutes = (props: any) => {
  const {
    pageType, startPoint, toPoint, company, isDesktop, calculatedParams, block, lang,
  } = props;
  const isVN = lang.lang === 'vi';
  const title = block?.headingContent?.title;
  const titleArr = title?.split('////');
  switch (pageType) {
    case SEO_PAGE_TYPE.AIRLINE_FROM_TO_PAGE:
      return (
        <>
          <PopularRoutesAirlineFromToCity
            title={titleArr?.[0]}
            company={company}
            startPoint={startPoint}
            toPoint={null}
            isDesktop={isDesktop}
            block={block}
            lang={lang}
            showToOnly
          />
          <PopularRoutesAirlineFromToCity
            title={titleArr?.[1]}
            // company={company}
            startPoint={null}
            toPoint={toPoint}
            block={block}
            isDesktop={isDesktop}
            lang={lang}
          />
          {isVN && (
            <>
              <CompanyToRouteVcms
                title={titleArr?.[2]}
                startPoint={startPoint}
                toPoint={toPoint}
              />
              <CompanyToRouteVcms
                startPoint={toPoint}
                toPoint={startPoint}
              />
            </>
          )}
        </>
      );
    case SEO_PAGE_TYPE.AIRLINE_PAGE:
      return (
        <>
          <PopularRoutesAirlineFromToCity
            company={company}
            startPoint={null}
            toPoint={toPoint}
            isDesktop={isDesktop}
            block={block}
            showToOnly
            lang={lang}
          />
          <PopularRoutesAirlineFromToCity
            company={company}
            startPoint={null}
            toPoint={toPoint}
            block={block}
            isDesktop={isDesktop}
            lang={lang}
          />
        </>
      );
    case SEO_PAGE_TYPE.AIRLINE_TO_PAGE:
      return (
        <PopularRoutesAirlineFromToCity
          title={title}
          company={company}
          startPoint={null}
          toPoint={null}
          isDesktop={isDesktop}
          block={block}
          showToOnly
          lang={lang}
        />
      );
    case SEO_PAGE_TYPE.TO_PAGE:
      return (
        <PopularRoutesAirlineFromToCity
          title={title}
          company={null}
          startPoint={null}
          toPoint={toPoint}
          block={block}
          isDesktop={isDesktop}
          lang={lang}
        />
      );
    case SEO_PAGE_TYPE.FROM_TO_PAGE:
      return (
        <>
          <PopularRoutesAirlineFromToCity
            title={titleArr?.[0]}
            company={null}
            startPoint={startPoint}
            toPoint={null}
            block={block}
            isDesktop={isDesktop}
            lang={lang}
          />
          <PopularRoutesAirlineFromToCity
            title={titleArr?.[1]}
            company={null}
            startPoint={null}
            toPoint={toPoint}
            block={block}
            isDesktop={isDesktop}
            lang={lang}
          />
          {isVN && (
            <>
              <CompanyToRouteVcms
                title={titleArr?.[2]}
                startPoint={startPoint}
                toPoint={toPoint}
              />
              <CompanyToRouteVcms
                startPoint={toPoint}
                toPoint={startPoint}
              />
            </>
          )}
        </>
      );
    case SEO_PAGE_TYPE.AIRPORT_PAGE:
      return (
        <PopularRoutesAirlineFromToCity
          title={title}
          company={null}
          startPoint={null}
          toPoint={startPoint}
          isDesktop={isDesktop}
          block={block}
          airport={calculatedParams?.airport}
          lang={lang}
        />
      );
    default:
      return <CompanyToRoute {...props} />;
  }
};

const CompanyFromToTableFareWithDescription = (props: any) => {
  const { block, flightDataAll, lang } = props;
  const todayStr = format(new Date(), 'yyyy-MM-dd');
  const airlineToday = (flightDataAll[todayStr] || []).map(
    (flight: any) => flight?.airline?.code,
  );

  return (block.paragraphs || [])
    .filter((paragraph: any) => airlineToday.includes(paragraph.airlineCode))
    .map((paragraph: any, subIdx: number) => (
      <div key={`${subIdx}`}>
        {/* <div dangerouslySetInnerHTML={{ __html: paragraph.content }} /> */}
        {convertStrToComp(paragraph?.content)}
        <AirlineFareInMonthTable
          {...props}
          lang={lang}
          airlineCode={paragraph?.airlineCode}
          hidePrice
        />
      </div>
    ));
};

const OtherCompanyFlight = ({
  startPoint,
  toPoint,
  isDesktop,
  company,
  pageType,
  block,
  lang,
}: any) => (
  <OtherCompanyFlightUrls
    startPoint={startPoint}
    toPoint={toPoint}
    airlineSlug={company}
    showToOnly={pageType === SEO_PAGE_TYPE.AIRLINE_TO_PAGE}
    isDesktop={isDesktop}
    block={block}
    lang={lang}
  />
);
const LunarNewYearAirfareByPolularRouteComp = ({
  handleSelectTrip, block, tetData,
}: any) => (
  <LunarNewYearAirfareByPolularRoute
    onSelectTrip={handleSelectTrip}
    block={block}
    tetData={tetData}
  />
);
const LunarNewYearAirfareByAirlineComp = ({
  handleSelectTrip, block, tetData,
}: any) => (
  <LunarNewYearAirfareByAirline
    onSelectTrip={handleSelectTrip}
    block={block}
    tetData={tetData}
  />
);
const NewYearAirfareByPolularRouteComp = ({
  handleSelectTrip, block, tetData,
}: any) => (
  <NewYearAirfareByPolularRoute
    onSelectTrip={handleSelectTrip}
    block={block}
    tetData={tetData}
  />
);

// CompanySeoBreadcrumbs
const vcmsComponentMapping = {
  'sections.navbar': HeaderBar,
  'layout.block': LayoutBlock,
  'layout.container': LayoutContainer,
  'elements.paragraph': ElementParagraph,
  'elements.notice': ElementNotice,
  'elements.flexi-component': ElementFlexiComponent,
  'elements.flexi-card': ElementFlexiCard,
  'elements.faq-list': ElementFAQList,
  'elements.breadcrumb': Breadcrumb,
  SearchBox,
  Banner: BannerDiscount,
  Partners,
  UniqueSellingPoints,
  SimpleFlightSearchBox: MiniSearchBox,
  TetHolidayPriceTable: NewYearFareTable,
  FareTable,
  FareInWeekTable,
  HorizontalFareBar,
  AirlineFareTable,
  FareCalendar,
  FareTableWithBar,
  NewYearFareCalendar,
  FareInMonthTable,
  AirlineFareInMonthTable,
  GeneralInfo,
  OtherFlightCompanyToCityUrls: CompanyToRoute,
  LowestPriceTodayTableWithBar: FareTableWithBar,
  LowestPriceTodayTable,
  PopularRoutesFromCity,
  PopularRoutesToCity,
  PopularRoutesFromToCity,
  AirlineIntroductions,
  CompanyBaggage,
  PopularRoutes,
  AirportToCity,
  CompanyToCityFlightSection: CompanyFromToTableFareWithDescription,
  OtherCompanyFlightUrls: OtherCompanyFlight,
  LunarNewYearAirfareByPolularRoute: LunarNewYearAirfareByPolularRouteComp,
  LunarNewYearAirfareByAirline: LunarNewYearAirfareByAirlineComp,
  NewYearAirfareByPolularRoute: NewYearAirfareByPolularRouteComp,
  FooterBar,
} as { [key: string]: (props: any) => JSX.Element };

export default CompanyPageVcmsBody;
